import { launchPrivider } from 'services/launch';

export const statusFreezing = async () => {
  const { data } = await launchPrivider.getstatusFreezing();

  return data;
};
